export default "__VITE_ASSET__AmhzOEb9__"